import axios from "axios";
import Config from "../utils/Config";
import dayjs from "dayjs";

class Middleware{
    // centralized API error handle for API calls. 
    static dispatch = null;
    static navigate = null;
    static openNotificationWithIcon = null;

    static setHelpers(dispatch, fn) {
      Middleware.dispatch = dispatch;
      Middleware.openNotificationWithIcon = fn;
    }

  constructor() {
    this.api = axios.create({
      baseURL: Config.BACKEND_URL,
      timeout: 100000,
    })

    this.api.interceptors.request.use((config) => {
      const token = config.headers.Authorization;
      if(token){
        try {
          const payload = JSON.parse(atob(token.split('.')[1]));
          const now = dayjs();
          if (payload.exp && dayjs.unix(payload.exp).isBefore(now)) {
            // Return a promise that resolves after the delay
            sessionStorage.setItem('sessionExpired', 'true');
            window.location.href = '/login';
          }
        } catch (error) {
          // 
        }
      }
      return config;
    })
    
    this.api.interceptors.response.use(
      (response) =>  {
        // Check if response is HTML when expecting JSON
        if (response.headers['content-type']?.includes('text/html')) {
          throw new Error('Received HTML instead of JSON');
        }
        return response;
      },
      (error) => {
        // Instead of displaying a message here, parse and attach a message Set a user-friendly message
        let displayMessage = 'Something went wrong. Please try again.';

        if (error.code === 'ECONNABORTED') {
          // Client-side Axios timeout
          // displayMessage = 'The server is taking too long to respond. Please try again in a few minutes.';
          displayMessage = 'Unable to process your request right now. Please try again in a few minutes.';
        } else if (error.response) {
          const status = error.response.status;
          const backendMsg = error.response.data?.message || '';
          
          if (status === 500 && backendMsg.includes('Timeout')) {
            // Backend timeout
            displayMessage = 'The server is taking too long to respond. Please try again in a few minutes.';
            // displayMessage = 'Unable to process your request right now. Please try again in a few minutes.';
          } else {
            displayMessage = backendMsg;
          }
        } else {
          // Other issues (like network errors)
          displayMessage = 'Network error. Please check your connection.';
        }

        // Attach custom message
        error.displayMessage = displayMessage;
        return Promise.reject(error); 
      }
    )
  }
}

export const MiddlewareClass = Middleware;
export default new Middleware();